import {
  SnippetElement,
  defineElement,
  on,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/common-newsletter/common-newsletter.ts
var CommonNewsletter = class extends SnippetElement {
  handleInputKeyDown(input, event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      input.click();
    }
  }
  handleSubmit(form, event) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f;
      event.preventDefault();
      const email = form.querySelector('input[name="EMAIL"]');
      if (email == null || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value.trim())) {
        this.showError((_a = form.dataset.msgInvalid) != null ? _a : "");
        email == null ? void 0 : email.focus();
        return;
      }
      const button = form.querySelector('[type="submit"]');
      button == null ? void 0 : button.setAttribute("disabled", "");
      this.hideMessages();
      try {
        const response = yield fetch(`${form.action}?isAjax=1`, { method: "POST", body: new FormData(form) });
        const data = yield response.json().catch(() => ({}));
        if (data.success === true) {
          this.showSuccess((_c = (_b = form.dataset.msgSuccess) != null ? _b : data.message) != null ? _c : "");
          form.reset();
        } else {
          const errors = data.errors != null ? Object.values(data.errors) : [];
          this.showError((_e = form.dataset.msgError) != null ? _e : errors.length > 0 ? errors.join(" ") : (_d = data.message) != null ? _d : "");
        }
      } catch (e) {
        this.showError((_f = form.dataset.msgError) != null ? _f : "");
      } finally {
        button == null ? void 0 : button.removeAttribute("disabled");
      }
    });
  }
  hideMessages() {
    var _a, _b;
    (_a = this.successBox) == null ? void 0 : _a.classList.add("hidden");
    (_b = this.errorBox) == null ? void 0 : _b.classList.add("hidden");
  }
  showSuccess(message) {
    this.hideMessages();
    if (this.successBox != null) {
      this.successBox.textContent = message;
      this.successBox.classList.remove("hidden");
    }
    if (this.statusBox != null)
      this.statusBox.textContent = message;
  }
  showError(message) {
    this.hideMessages();
    if (this.errorBox != null) {
      this.errorBox.textContent = message;
      this.errorBox.classList.remove("hidden");
    }
    if (this.statusBox != null)
      this.statusBox.textContent = message;
  }
};
__decorateClass([
  query("[data-newsletter-success]")
], CommonNewsletter.prototype, "successBox", 2);
__decorateClass([
  query("[data-newsletter-error]")
], CommonNewsletter.prototype, "errorBox", 2);
__decorateClass([
  query("[data-newsletter-status]")
], CommonNewsletter.prototype, "statusBox", 2);
__decorateClass([
  on("keydown", 'input[type="checkbox"]')
], CommonNewsletter.prototype, "handleInputKeyDown", 1);
__decorateClass([
  on("submit", "[data-newsletter-form]")
], CommonNewsletter.prototype, "handleSubmit", 1);
CommonNewsletter = __decorateClass([
  defineElement("common-newsletter")
], CommonNewsletter);
export {
  CommonNewsletter
};
